<template>
	<div style="width: 100vw;">
		<!-- background-color: rgb(0 0 0 / 0%); -->
		<van-overlay z-index="100000000000000" :show="loading" style="background-color: rgb(0 0 0 / 0%);">
			<div style="display: flex;align-items: center;justify-content: center;width: 100%;height: 100%;">
				<van-loading color="#7d7d7d" type="spinner" />
			</div>
		</van-overlay>
		<div :style="{
			minHeight:`calc(100vh - ${placeNavHeight}px)`
		}">
			<div v-if="localPageData && showPage">
				<div v-if="equipment == 'pc'" style="height: 30px;width: 100%;"></div>
				<div v-if="equipment == 'pc'"
					style="display: flex;background-color: #f5f5f5;width: 1280px;margin: auto;">
					<div style="width: calc(62% - 15px);background-color: #ffffff;padding: 20px;padding-left: 11%;">
						<div style="font-size: 16px;font-weight: bold;">
							{{$t('h.sippingAddress')}}
						</div>
						<!-- <div style="width: 80%;height: 1px;background-color: #d4d4d4;margin-top: 20px;"></div> -->
						<el-form label-position="top" size="16" style="width: 80%;" :model="form" :rules="rules"
							ref="ruleForm" label-width="100px" class="demo-ruleForm">
							<div>
								<div style="display: flex;align-items: center;width: 100%;margin-top: 10px;">
									<!-- <el-form-item prop="name" style="width: 50%;" :label="$t('h.name')">
										<el-input v-model="form.name" :placeholder="$t('h.name')"></el-input>
									</el-form-item> -->
									<el-form-item prop="first_name" style="width: 50%;" :label="$t('h.first_name')">
										<el-input v-model="form.first_name"
											:placeholder="$t('h.first_name')"></el-input>
									</el-form-item>

									<el-form-item prop="last_name" style="width: 50%;margin-left: 10px;"
										:label="$t('h.last_name')">
										<el-input v-model="form.last_name" :placeholder="$t('h.last_name')"></el-input>
									</el-form-item>
									<!-- <el-form-item v-if="!getCookie('login')" prop="email" style="width: 50%;margin-left: 10px;" :label="$t('h.email')">
										<el-input v-model="form.email" :placeholder="$t('h.email')"></el-input>
									</el-form-item>
									
									<el-form-item v-if="getCookie('login')" prop="address1" style="" style="width: 50%;margin-left: 10px;" :label="$t('h.address1')">
										<el-input v-model="form.address1" :placeholder="$t('h.address1')"></el-input>
									</el-form-item> -->

								</div>

								<div style="display: flex;align-items: center;width: 100%;margin-top: 10px;">
									<el-form-item v-if="!getCookie('login')" prop="email" style="width: 50%;"
										:label="$t('h.email')">
										<el-input v-model="form.email" :placeholder="$t('h.email')"></el-input>
									</el-form-item>

									<div v-if="localPageData.shipping_require" :style="{
											width:!getCookie('login')?'50%':'100%',
											marginLeft:!getCookie('login')?'10px':'0px'
										}" style="display: flex;align-items: center;">
										<el-form-item prop="address1" style="" style="width: 100%;"
											:label="$t('h.address1')">
											<el-input v-model="form.address1"
												:placeholder="$t('h.address1')"></el-input>
										</el-form-item>
									</div>
								</div>


								<div v-if="localPageData.shipping_require"
									style="display: flex;align-items: center;width: 100%;">
									<el-form-item prop="address2" style="width: 50%;" :label="$t('h.address2')">
										<el-input v-model="form.address2" :placeholder="$t('h.address2')"></el-input>
									</el-form-item>
									<el-form-item prop="emailCode" style="margin-left: 10px;width: 50%;"
										:label="$t('h.emailCode')">
										<el-input v-model="form.emailCode" :placeholder="$t('h.emailCode')"></el-input>
									</el-form-item>
								</div>
								<div style="display: flex;align-items: center;width: 100%;">
									<el-form-item prop="phone" style="width: 50%;" :label="$t('h.phone')">
										<el-input v-model="form.phone" :placeholder="$t('h.phone')"></el-input>
									</el-form-item>
									<el-form-item v-if="localPageData.shipping_require" prop="city"
										style="margin-left: 10px;width: 50%;" :label="$t('h.city')">
										<el-input v-model="form.city" :placeholder="$t('h.city')"></el-input>
									</el-form-item>
								</div>
								<div v-if="localPageData.shipping_require"
									style="display: flex;align-items: center;width: 100%;">
									<el-form-item prop="country" style="width: 50%;" :label="$t('h.country')">
										<el-select style="width: 100%;" @change="changeCountries" v-model="form.country"
											:placeholder="$t('h.country')">
											<el-option v-for="item in localPageData.countries" :key="item.id"
												:label="item.name" :value="item.id">
											</el-option>
										</el-select>
									</el-form-item>
									<el-form-item prop="province" style="width: 50%;margin-left: 10px;"
										:label="$t('h.province')">
										<el-select @change="changeProvince" style="width: 100%;"
											loading-text="Loading..." no-data-text="Empty" :loading="selectLoading"
											v-model="form.province" :placeholder="$t('h.province')">
											<el-option v-for="item in localPageData.zones" :key="item.id"
												:label="item.name" :value="item.id">
											</el-option>
										</el-select>
									</el-form-item>
								</div>
							</div>
						</el-form>
						<div v-if="localPageData.payment_methods.length >  0"
							style="font-size: 16px;font-weight: bold;margin-top: 20px;">
							{{$t('h.payWay')}}
						</div>

						<div v-if="localPageData.payment_methods.length ==  0"
							style="font-size: 16px;font-weight: bold;margin-top: 20px;">
							{{$t('h.noPayWay')}}
						</div>

						<!-- <div style="width: 80%;height: 1px;background-color: #d4d4d4;margin-top: 20px;"></div> -->
						<div v-loading="loadingPayWay">
							<div style="width: 80%;margin-top: 20px;"
								v-for="(item,index) in localPageData.payment_methods" :key="index">
								<div :style="{
									border: form.payWay == item.code? 'solid 1px #d4d4d4':'none'
								}" @click="changePayWay(item)"
									style="padding: 10px;width: calc(100% - 20px);display: flex;align-items: center;cursor: pointer;">
									<div style="width: 15px;height: 15px;">
										<el-radio v-model="form.payWay" :label="item.code"><span></span></el-radio>
									</div>
									<img :src="item.icon" style="width: 60px;height: 60px;margin-left: 15px;" />
									<div style="margin-left: 20px;">
										<div style="font-weight: bold;font-size: 16px;">{{item.code}}</div>
										<div style="font-size: 14px;margin-top: 10px;">{{item.name}}</div>
									</div>
								</div>
							</div>
						</div>



						<div v-if="localPageData.shipping_require && localPageData.shipping_methods.length > 0"
							style="font-size: 16px;font-weight: bold;margin-top: 20px;">
							{{$t('h.sendWay')}}
						</div>


						<div v-if="localPageData.shipping_methods.length ==  0"
							style="font-size: 16px;font-weight: bold;margin-top: 20px;">
							{{$t('h.noTransportation')}}
						</div>

						<!-- <div style="width: 80%;height: 1px;background-color: #d4d4d4;margin-top: 20px;"></div> -->
						<div style="width: 80%;margin-top: 20px;"
							v-if="localPageData.shipping_require && localPageData.shipping_methods.length > 0">
							<div v-for="(item,index) in localPageData.shipping_methods[0].quotes" :key="index"
								style="padding: 10px;width: calc(100% - 20px);border: solid 1px #d4d4d4;display: flex;align-items: center;">
								<div style="width: 15px;height: 15px;">
									<el-radio v-model="form.sendWay" :label="item.code"><span></span></el-radio>
								</div>
								<img :src="item.icon" style="width: 60px;height: 60px;margin-left: 15px;" />
								<div style="margin-left: 20px;">
									<div style="font-weight: bold;font-size: 16px;">{{item.name}}</div>
									<div style="font-size: 14px;margin-top: 10px;">{{item.description}}</div>
								</div>
							</div>
						</div>

						<div style="font-size: 16px;font-weight: bold;margin-top: 20px;">
							{{$t('h.orderRemarks')}}
						</div>
						<!-- <div style="width: 80%;height: 1px;background-color: #d4d4d4;margin-top: 20px;"></div> -->
						<div style="width: 80%;margin-top: 20px;">
							<el-input type="textarea" :rows="3" :placeholder="$t('h.orderRemarks')">
							</el-input>
						</div>
					</div>
					<div style="width: calc(35% - 15px);height: 100%;margin-left: 30px;">
						<div v-if="loginShow" style="background-color: #fff;width: calc(100% - 40px);padding: 20px;">
							<div style="font-size: 16px;font-weight: bold;">{{$t('h.loginText')}}</div>
							<el-button class="btn" style="margin-top: 20px;"
								@click="dialogVisible = true;iframeLogin = true">{{$t('h.loginText')}}</el-button>
						</div>
						<div style="background-color: #fff;width: calc(100% - 40px);padding: 20px;" :style="{
							marginTop:loginShow?'20px':'0px'
						}">
							<div
								style="font-size: 16px;font-weight: bold;width: 100%;display: flex;justify-content: space-between;">
								<div>
									{{$t('h.cartNum')}}
								</div>
								<div
									style="height: 26px;width: 26px;border-radius: 100%;background-color: #fd560f;display: flex;align-items: center;justify-content: center;color: #fff;font-size: 14px;font-weight: normal;">
									{{localPageData.carts.quantity_all}}
								</div>
							</div>
							<!-- <div
								style="width: 100%;height: 1px;background-color: #d1d1d1;width: 100%;margin-top: 20px;">
							</div> -->
							<div style="width: 100%;max-height: 600px;margin-top: 20px;overflow-y: scroll;">
								<div v-for="(item,index) in localPageData.carts.carts" :key="index"
									style="display: flex;align-items: center;margin: 10px 0px;">
									<img style="width: 48px;height: 48px;" :src="item.image_url" />
									<div style="margin-left: 10px;width: 100%;font-size: 14px;">
										<div class="text-ellipsis">
											{{item.name}}
										</div>
										<div>
											{{item.variant_labels}}
										</div>
									</div>
									<div
										style="color: #adadad;font-size: 14px;display: flex;justify-content: flex-end;flex-direction: column;margin-left: 10px;">
										<div>
											{{item.price_format}}
										</div>
										<div style="margin-top: 6px;">
											x{{item.quantity}}
										</div>
									</div>
								</div>
							</div>
							<!-- <div
								style="width: 100%;height: 1px;background-color: #d1d1d1;width: 100%;margin-top: 20px;">
							</div> -->

							<div style="width: 100%;font-size: 14px;">
								<div style="display: flex;justify-content: space-between;width: 100%;margin-top: 20px;"
									v-for="(item,index) in localPageData.totals" :key="index">
									<div>{{item.title}}</div>
									<div>{{item.amount_format}}</div>
								</div>
							</div>
							<div style="margin-top: 20px;">
								<el-input style="cursor: pointer;" v-loading="loadingApply" v-model="form.checkCode"
									:placeholder="$t('h.discountCode')">
									<template slot="append">
										<span @click="checkCode">{{$t('h.apply')}}</span>
									</template>
								</el-input>
							</div>
							<div style="margin-top: 20px;width: 100%;">
								<div v-if="account == 0 && payWayCode == 'paypal' && !loadingPayWay"
									id="paypal-button-container" style="margin-top: 20px;" class="mt-4"></div>
								<el-button v-if="(account == 1)?true:payWayCode != 'paypal'" :loading="submitLoading"
									:style="{
									'--bgColor':(loadingApply || loadingPayWay) && !canPay?'#7f7f7f':'#000000'
								}" class="btn-submit" style="width: 100%;user-select:none;"
									@click="submitOrder()">{{$t('h.submitOrder')}}</el-button>
							</div>
						</div>
					</div>
				</div>
				<div v-if="equipment == 'pc'" style="height: 30px;width: 100%;"></div>
				<div v-if="equipment == 'phone'" style="background-color: #f6f8fa;padding: 10px;">
					<div v-if="loginShow" style="background-color: #fff;margin: auto;padding: 10px;">
						<div style="font-size: 16px;font-weight: bold;">{{$t('h.loginText')}}</div>
						<el-button class="btn" style="margin-top: 20px;"
							@click="dialogVisible = true;iframeLogin = true">{{$t('h.loginText')}}</el-button>
					</div>
					<el-form label-position="top" size="16"
						style="margin: auto;background-color: #fff;padding: 10px;margin-top: 15px;" :model="form"
						:rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm">
						<div>
							<div style="display: flex;align-items: center;">
								<!-- 	<el-form-item prop="name" :label="$t('h.name')">
									<el-input v-model="form.name" :placeholder="$t('h.name')"></el-input>
								</el-form-item> -->
								<!-- 	<el-form-item prop="address1" style="margin-left: 10px;" :label="$t('h.address1')">
									<el-input v-model="form.address1" :placeholder="$t('h.address1')"></el-input>
								</el-form-item> -->
								<!-- <el-form-item v-if="!getCookie('login')" prop="email" style="margin-left: 10px;" :label="$t('h.email')">
									<el-input v-model="form.email" :placeholder="$t('h.email')"></el-input>
								</el-form-item>
								
								<el-form-item v-if="getCookie('login')" prop="address1" style="" style="margin-left: 10px;" :label="$t('h.address1')">
									<el-input v-model="form.address1" :placeholder="$t('h.address1')"></el-input>
								</el-form-item> -->
								<el-form-item prop="first_name" style="width: 50%;" :label="$t('h.first_name')">
									<el-input v-model="form.first_name" :placeholder="$t('h.first_name')"></el-input>
								</el-form-item>
								<el-form-item prop="last_name" style="width: 50%;margin-left: 10px;"
									:label="$t('h.last_name')">
									<el-input v-model="form.last_name" :placeholder="$t('h.last_name')"></el-input>
								</el-form-item>
								<!-- <el-form-item prop="email" style="margin-left: 10px;" :label="$t('h.email')">
									<el-input v-model="form.email" :placeholder="$t('h.email')"></el-input>
								</el-form-item> -->
							</div>

							<!-- <el-form-item v-if="!getCookie('login')" prop="email" style="margin-left: 10px;"
								:label="$t('h.email')">
								<el-input v-model="form.email" :placeholder="$t('h.email')"></el-input>
							</el-form-item>
			
							<el-form-item v-if="getCookie('login')" prop="address1" style="" :label="$t('h.address1')">
								<el-input v-model="form.address1" :placeholder="$t('h.address1')"></el-input>
							</el-form-item> -->

							<div style="display: flex;align-items: center;width: 100%;margin-top: 10px;">
								<el-form-item v-if="!getCookie('login')" prop="email" style="width: 50%;"
									:label="$t('h.email')">
									<el-input v-model="form.email" :placeholder="$t('h.email')"></el-input>
								</el-form-item>

								<div v-if="localPageData.shipping_require" :style="{
										width:!getCookie('login')?'50%':'100%',
										marginLeft:!getCookie('login')?'10px':'0px'
									}" style="display: flex;align-items: center;">
									<el-form-item prop="address1" style="" style="width: 100%;"
										:label="$t('h.address1')">
										<el-input v-model="form.address1" :placeholder="$t('h.address1')"></el-input>
									</el-form-item>
								</div>
							</div>


							<div v-if="localPageData.shipping_require" style="display: flex;align-items: center;">
								<el-form-item prop="address2" :label="$t('h.address2')">
									<el-input v-model="form.address2" :placeholder="$t('h.address2')"></el-input>
								</el-form-item>
								<el-form-item prop="emailCode" style="margin-left: 10px;" :label="$t('h.emailCode')">
									<el-input v-model="form.emailCode" :placeholder="$t('h.emailCode')"></el-input>
								</el-form-item>
							</div>

							<div style="display: flex;align-items: center;">
								<el-form-item prop="phone" :label="$t('h.phone')">
									<el-input v-model="form.phone" :placeholder="$t('h.phone')"></el-input>
								</el-form-item>
								<el-form-item v-if="localPageData.shipping_require" prop="city"
									style="margin-left: 10px;" :label="$t('h.city')">
									<el-input v-model="form.city" :placeholder="$t('h.city')"></el-input>
								</el-form-item>
							</div>

							<div v-if="localPageData.shipping_require" style="display: flex;align-items: center;">
								<el-form-item prop="country" :label="$t('h.country')">
									<el-select @change="changeCountries" v-model="form.country"
										:placeholder="$t('h.country')">
										<el-option v-for="item in localPageData.countries" :key="item.id"
											:label="item.name" :value="item.id">
										</el-option>
									</el-select>
								</el-form-item>
								<el-form-item style="margin-left: 10px;" prop="province" :label="$t('h.province')">
									<el-select @change="changeProvince" loading-text="Loading..." no-data-text="Empty"
										:loading="selectLoading" v-model="form.province"
										:placeholder="$t('h.province')">
										<el-option v-for="item in localPageData.zones" :key="item.id" :label="item.name"
											:value="item.id">
										</el-option>
									</el-select>
								</el-form-item>
							</div>
						</div>
					</el-form>

					<div style="margin: auto;background-color: #fff;margin-top: 15px;padding: 10px;">
						<div v-if="localPageData.payment_methods.length >  0"
							style="font-size: 16px;font-weight: bold;margin-top: 10px;">
							{{$t('h.payWay')}}
						</div>

						<div v-if="localPageData.payment_methods.length ==  0"
							style="font-size: 16px;font-weight: bold;margin-top: 20px;">
							{{$t('h.noPayWay')}}
						</div>

						<!-- <div style="width: 100%;height: 1px;background-color: #d4d4d4;margin-top: 10px;"></div> -->
						<div v-loading="loadingPayWay">
							<div style="width: 100%;margin-top: 10px;"
								v-for="(item,index) in localPageData.payment_methods" :key="index">
								<div :style="{
										border: form.payWay == item.code? 'solid 1px #d4d4d4':'none'
									}" @click="changePayWay(item)"
									style="padding: 10px;width: calc(100% - 20px);display: flex;align-items: center;cursor: pointer;">
									<div style="width: 15px;height: 15px;">
										<el-radio v-model="form.payWay" :label="item.code"><span></span></el-radio>
									</div>
									<img :src="item.icon" style="width: 60px;height: 60px;margin-left: 15px;" />
									<div style="margin-left: 20px;">
										<div style="font-weight: bold;font-size: 16px;">{{item.code}}</div>
										<div style="font-size: 14px;margin-top: 10px;">{{item.name}}</div>
									</div>
								</div>
							</div>
						</div>
						<div v-if="localPageData.shipping_require  && localPageData.shipping_methods.length > 0"
							style="font-size: 16px;font-weight: bold;margin-top: 10px;">
							{{$t('h.sendWay')}}
						</div>

						<div v-if="localPageData.shipping_methods.length ==  0"
							style="font-size: 16px;font-weight: bold;margin-top: 20px;">
							{{$t('h.noTransportation')}}
						</div>

						<!-- <div style="width: 100%;height: 1px;background-color: #d4d4d4;margin-top: 10px;"></div> -->
						<div style="width: 100%;margin-top: 10px;"
							v-if="localPageData.shipping_require  && localPageData.shipping_methods.length > 0">
							<div v-for="(item,index) in localPageData.shipping_methods[0].quotes" :key="index"
								style="padding: 10px;width: calc(100% - 20px);border: solid 1px #d4d4d4;display: flex;align-items: center;">
								<div style="width: 15px;height: 15px;">
									<el-radio v-model="form.sendWay" :label="item.code"><span></span></el-radio>
								</div>
								<img :src="item.icon" style="width: 60px;height: 60px;margin-left: 15px;" />
								<div style="margin-left: 20px;">
									<div style="font-weight: bold;font-size: 16px;">{{item.name}}</div>
									<div style="font-size: 14px;margin-top: 10px;">{{item.description}}</div>
								</div>
							</div>
						</div>

						<div style="font-size: 16px;font-weight: bold;margin-top: 10px;">
							{{$t('h.orderRemarks')}}
						</div>
						<!-- <div style="width: 100%;height: 1px;background-color: #d4d4d4;margin-top: 10px;"></div> -->
						<div style="width: 100%;margin-top: 10px;">
							<el-input type="textarea" :rows="3" :placeholder="$t('h.orderRemarks')">
							</el-input>
						</div>
						<div style="margin-top: 20px;">
							<el-input v-loading="loadingApply" v-model="form.checkCode"
								:placeholder="$t('h.discountCode')">
								<template slot="append">
									<span @click="checkCode" style="cursor: pointer;">{{$t('h.apply')}}</span>
								</template>
							</el-input>
						</div>
					</div>

					<div style="margin-top: auto;background-color: #fff;margin-top: 15px;">
						<!-- <div style="background-color: #fff;width: calc(100% - 40px);padding: 20px;">
								<div style="font-size: 16px;font-weight: bold;">{{$t('h.loginText')}}</div>
								<el-button class="btn" style="margin-top: 20px;"
									@click="dialogVisible = true;iframeLogin = true">{{$t('h.loginText')}}</el-button>
							</div> -->
						<div style="background-color: #fff;width: calc(100% - 40px);padding: 20px;margin-top: 20px;">
							<div
								style="font-size: 16px;font-weight: bold;width: 100%;display: flex;justify-content: space-between;">
								<div>
									{{$t('h.cartNum')}}
								</div>
								<div
									style="height: 26px;width: 26px;border-radius: 100%;background-color: #fd560f;display: flex;align-items: center;justify-content: center;color: #fff;font-size: 14px;font-weight: normal;">
									{{localPageData.carts.quantity_all}}
								</div>
							</div>
							<div
								style="width: 100%;height: 1px;background-color: #d1d1d1;width: 100%;margin-top: 20px;">
							</div>
							<div style="width: 100%;max-height: 600px;margin-top: 20px;overflow-y: scroll;">
								<div v-for="(item,index) in localPageData.carts.carts" :key="index"
									style="display: flex;align-items: center;margin: 10px 0px;">
									<img style="width: 48px;height: 48px;" :src="item.image_url" />
									<div style="margin-left: 10px;width: 100%;font-size: 14px;">
										<div class="text-ellipsis">
											{{item.name}}
										</div>
										<div>
											{{item.variant_labels}}
										</div>
									</div>
									<div
										style="color: #adadad;font-size: 14px;display: flex;justify-content: flex-end;flex-direction: column;margin-left: 10px;">
										<div>
											{{item.price_format}}
										</div>
										<div style="margin-top: 6px;">
											x{{item.quantity}}
										</div>
									</div>
								</div>
							</div>
							<!-- <div
								style="width: 100%;height: 1px;background-color: #d1d1d1;width: 100%;margin-top: 20px;">
							</div> -->

							<div style="width: 100%;font-size: 14px;">
								<div style="display: flex;justify-content: space-between;width: 100%;margin-top: 20px;"
									v-for="(item,index) in localPageData.totals" :key="index">
									<div>{{item.title}}</div>
									<div>{{item.amount_format}}</div>
								</div>
							</div>
							<!-- <div style="margin-top: 20px;width: 100%;">
									<el-button :loading="submitLoading" :style="{
										'--bgColor':loadingApply || loadingPayWay?'#7f7f7f':'#000000'
									}" class="btn-submit" style="width: 100%;" @click="submitOrder()">{{$t('h.submitOrder')}}</el-button>
								</div> -->
						</div>
					</div>
					<div style="height: 10px;width: 100%;background-color: #f6f8fa;"></div>
					<!-- <div style="height: 68px;"></div> -->

				</div>
				<div v-if="equipment == 'phone'"
					style="height: 68px;position: fixed;bottom: 0px;width: 100%;background-color: #fff;display: flex;align-items: center;justify-content: space-between;left: 0px;z-index: 10000;">
					<div v-if="item.code == 'order_total'"
						style="display: flex;justify-content: space-between;margin-left: 10px;"
						v-for="(item,index) in localPageData.totals" :key="index">
						<div>{{item.title}}</div>
						<div style="margin-left: 10px;">{{item.amount_format}}</div>
					</div>

					<div v-if="account == 0 && payWayCode == 'paypal'  && !loadingPayWay" id="paypal-button-container"
						style="width: fit-content;margin-right: 10px;user-select:none;" class="mt-4 btn-submit"></div>
					<el-button v-if="(account == 1 )?true:payWayCode != 'paypal'" :loading="submitLoading" :style="{
							'--bgColor':(loadingApply || loadingPayWay) && !canPay?'#7f7f7f':'#000000'
						}" class="btn-submit" style="width: fit-content;margin-right: 10px;user-select:none;"
						@click="submitOrder()">{{$t('h.submitOrder')}}</el-button>
				</div>
				<el-dialog title="" :visible.sync="dialogVisible" :width="equipment == 'phone'?'90%':'60%'"
					:before-close="()=>{dialogVisible = false}">
					<div v-loading="iframeLogin">
						<iframe v-if="dialogVisible" id="iframe" style="width: 100%;min-height: 650px;" ref="iframe"
							src="/login?iframe=true" frameborder="0" scrolling="auto"
							@load="iframeLogin = false"></iframe>
					</div>
				</el-dialog>
			</div>
		</div>

		<!-- <el-dialog :title="$t('h.success_order_checkoutPage')" :visible.sync="dialogVisiblePaypal"
			:width="equipment == 'phone'?'96%':'60%'" :before-close="()=>{
			  dialogVisiblePaypal = false
		  }">

			<div v-loading="iframeLoading">
				<iframe @load="iframeLoading = false" name="paypalIframe" id="iframeForm" scrolling="auto"
					src="about:blank" style="width: 100%;height: 600px;border: solid 0px #fff;"></iframe>
				<form id="paypalForm" v-if="paypalData.action" style="overflow: hidden;" :action="paypalData.action"
					method="post">
					  <input type="hidden" name="cmd" value="_xclick">
					  <input type="hidden" name="custom" :value="paypalData.custom">
					  <input type="hidden" name="item_number" :value="paypalData.item_number">
					  <input type="hidden" name="item_name" :value="paypalData.item_name">
					  <input type="hidden" name="business" :value="paypalData.business">
					  <input type="hidden" name="amount" :value="paypalData.amount">
					  <input type="hidden" name="currency_code" :value="paypalData.currency_code">
					  <input type="hidden" name="return" :value="paypalData.return">
					  <input type="hidden" name="notify_url" :value="paypalData.notify_url">
					  <input type="hidden" name="cancel_return" :value="paypalData.cancel_return">
					<input ref="orderSub"
						style="width: 70%;height: 56px;background-color: #ffaa00 ;border: solid 0px #ffffff;margin-top: 20px;border-radius: 6px;cursor: pointer;display: none;"
						type="submit" name="submit" :value="$t('h.subPay')">
				</form>
			</div>
		</el-dialog> -->



	</div>
</template>

<script>
	import facebookPixel from '../../../facebookPixel'
	import $ from 'jquery'
	import Cookies from 'js-cookie'
	import {
		getZones,
		getCheckoutData,
		getCheckCode,
		getCheckoutPayWay,
		getCheckoutAddresses,
		getCheckoutConfirm,
		getcheckoutAddress
	} from '../../../api/all.js'
	export default {
		props: {
			placeNavHeight: {
				type: Number,
				default: 0
			},
			equipment: {
				type: String,
				default: "pc"
			},
			// localPageData: {
			// 	type: Object,
			// 	default: () => {
			// 		return {}
			// 	}
			// },
		},

		data() {
			return {
				payPalOrderIdOld: "",
				jumpUrl: "",
				clientKey: "",
				account: 1,
				jump: 1,
				iframeLoading: false,
				payPalSingleUrl: "",
				paypalData: {},
				payWayCode: "paypal",
				dialogVisiblePaypal: false,
				canPay: true,
				showPage: false,
				localPageData: null,
				loading: false,
				loginShow: false,
				userInfo: {},
				submitLoading: false,
				loadingPayWay: false,
				loadingApply: false,
				dialogVisible: false,
				iframeLogin: false,
				form: {
					sendWay: '',
					payWay: '',
					first_name: '',
					last_name: '',
					// name: '',
					email: '',
					address1: '',
					address2: '',
					emailCode: '',
					phone: '',
					city: '',
					country: '',
					province: '',
					comment: "",
					checkCode: ""
				},

				selectLoading: false,
				checkoutData: null,
				ruleForm: {
					name: '',
					region: '',
					date1: '',
					date2: '',
					delivery: false,
					type: [],
					resource: '',
					desc: ''
				},
				rules: {

					first_name: [{
						required: true,
						message: this.$t('h.first_nameError'),
						trigger: ['blur', 'change']
					}, ],
					last_name: [{
						required: true,
						message: this.$t('h.last_nameError'),
						trigger: ['blur', 'change']
					}, ],

					email: [{
							required: true,
							message: this.$t('h.errorEmail'),

							trigger: ['blur', 'change']
						},
						{
							validator: this.checkEmail,
							trigger: 'blur'
						}
					],
					city: [{
						required: true,
						message: this.$t('h.city'),
						trigger: ['blur', 'change']
					}, ],
					// name: [{
					// 	required: true,
					// 	message: this.$t('h.nameError'),
					// 	trigger: ['blur', 'change']
					// }, ],
					address1: [{
						required: true,
						message: this.$t('h.address1Error'),
						trigger: ['blur', 'change']
					}, ],
					country: [{
						required: true,
						message: this.$t('h.countryError'),
						trigger: ['blur', 'change']
					}, ],
					province: [{
						required: true,
						message: this.$t('h.provinceError'),
						trigger: ['blur', 'change']
					}, ],

					phone: [{
						required: true,
						message: this.$t('h.phone'),
						trigger: ['blur', 'change']
					}, ],
					emailCode: [{
						required: true,
						message: this.$t('h.emailCode'),
						trigger: ['blur', 'change']
					}, ],
				}
			}
		},
		async mounted() {
			let that = this
			console.log('allCookiesallCookies', document.cookie);
			console.log('allCookiesallCookies', this.getCookie('login'));
			await this.initGetData()
			if (this.getCookie('login')) {
				console.log(this.loginShow, 'this.loginShow')
				this.loginShow = false
			} else {
				this.loginShow = true
			}
			console.log('getCheckoutData', this.localPageData)
			if (this.localPageData.payment_methods.length > 0) {
				this.form.payWay = this.localPageData.payment_methods[0].code
				this.changePayWay(this.localPageData.payment_methods[0])

			}
			if (this.localPageData.shipping_require && this.localPageData.shipping_methods.length > 0) {
				if (this.localPageData.shipping_methods[0].quotes.length > 0) {
					this.form.sendWay = this.localPageData.shipping_methods[0].quotes[0].code
				}
			}

			if (this.localPageData.shipping_methods.length == 0 || this.localPageData.payment_methods.length == 0) {
				this.canPay = false
			}


			if (this.localPageData.country_id) {
				// 存在国家id再加
				this.localPageData.countries.forEach(item => {
					if (item.id == this.localPageData.country_id) {
						this.form.country = this.localPageData.country_id
					}
				})
				console.log('this.form.country', this.form.country)

			}
			this.initForm()
			window.addEventListener('message', function(event) {
				if (event && event.data.type == 'apiLoginResponse' && event.data.data.status == "success") {
					that.dialogVisible = false
					that.loginShow = false
					that.$router.go(0)
					// localStorage.setItem('address', JSON.stringify(event.data.data.data))
					// that.initForm()
					console.log('event', event)
				}
			});

			// window.addEventListener('message', function(event) {
			// 	console.log('1234756event')
			// 	console.log('123456event', event)

			// 	// if (event && event.data.type == 'checkoutMessage' && event.data.data.status == "success") {

			// 	// 	alert(event.data.message)
			// 	// }
			// });

			this.showPage = true

			// this.createPaypay()
		},
		methods: {
			loadScript(src, name) {
				return new Promise((resolve, reject) => {
					// 先检查是否已存在同名script标签
					const existingScript = document.querySelector(`script[name="${name}"]`);

					if (existingScript) {
						// 如果已存在，先移除
						existingScript.parentNode.removeChild(existingScript);
					}

					// 创建新的script标签
					const script = document.createElement('script');
					script.src = src;
					script.name = name; // 设置name属性以便后续识别
					script.async = true;

					// 加载成功回调
					script.onload = () => {
						resolve();
					};

					// 加载失败回调
					script.onerror = () => {
						reject(new Error(`Failed to load script: ${src}`));
					};

					// 添加到文档中
					document.head.appendChild(script);
				});
			},

			async createPaypay() {
				let key = this.clientKey
				let currency_code = this.currencyCode
				let orderId;
				let actions;
				await this.loadScript(
					`https://www.paypal.com/sdk/js?client-id=${key}&currency=${currency_code}`,
					'paypay');
				let that = this
				let payPalStyle = {}
				if (this.equipment == 'phone') {
					payPalStyle = {
						displayOnly: ["vaultable"],
						layout: 'horizontal',
						tagline: false
					}
				}

				paypal.Buttons({
					style: {
						...payPalStyle
					},

					createOrder: function(data, actions) {
						let isOk = true
						that.$refs['ruleForm'].validate((valid) => {
							if (!valid) {
								isOk = false
							}
						})
						if(!isOk) {
							that.$message.error(that.$t('h.sippingAddress') + ' Incorrect')
							return
						}
						
						that.loading = true
						console.log('that.payPalOrderIdOld', that.payPalOrderIdOld)
						if (!that.payPalOrderIdOld) {
							return getCheckoutPayWay({
								guest_payment_address: {
									address_1: that.form.address1,
									address_2: that.form.address2 ? that.form.address2 : "",
									city: that.form.city,
									country_id: that.form.country,
									default: true,
									email: that.form.email,
									name: that.form.first_name + ' ' + that.form.last_name,

									first_name: that.form.first_name,
									last_name: that.form.last_name,
									phone: that.form.phone,
									zipcode: that.form.emailCode,
									zone_id: that.form.province,
								},
								guest_shipping_address: {
									address_1: that.form.address1,
									address_2: that.form.address2 ? that.form.address2 : "",
									city: that.form.city,
									country_id: that.form.country,
									default: true,
									email: that.form.email,
									name: that.form.first_name + ' ' + that.form.last_name,
									first_name: that.form.first_name,
									last_name: that.form.last_name,
									phone: that.form.phone,
									zipcode: that.form.emailCode,
									zone_id: that.form.province,
								}
							}).then(function(addressData) {
								facebookPixel.track('AddPaymentInfo',{
									eventID: 'unique_event_id_' + Date.now() // 使用时间戳或其他唯一ID
								});
								return getCheckoutConfirm({
									comment: that.form.comment
								}).then(function(data) {
									if (data.data.number) {
										orderId = data.data.number
										that.payPalOrderIdOld = data.data.number
										const token = $('meta[name="csrf-token"]').attr(
											'content')
										let url = '/paypal/create'
										if (that.jump == 1) {
											
											
											
											url = '/paypal/createUrl'
										}
										return fetch(url, {
											method: 'POST',
											headers: {
												'X-CSRF-Token': token
											},
											body: JSON.stringify({
												orderNumber: orderId,
												url:that.jumpUrl 
											})
										}).then(function(res) {
											return res.json();
										}, err => {
											that.$message.error(err.message)
											setTimeout(()=>{
												if (that.payPalOrderIdOld) {
													that.$router.replace({
														path: '/orders/' + that.payPalOrderIdOld + '/pay',
														query: {
															type: 'create'
														}
													})
												}
											},800)
											
										}).then(function(orderData) {
											if (orderData.error) {
												that.$message.error(common
													.text_hint)
												window.location.reload();
											}
											return orderData.id;
										}, err => {
											that.$message.error(err.message)
											setTimeout(()=>{
												if (that.payPalOrderIdOld) {
													that.$router.replace({
														path: '/orders/' + that.payPalOrderIdOld + '/pay',
														query: {
															type: 'create'
														}
													})
												}
											},800)
										});
									}
								}, err => {
									that.loading = false
									that.$message.error(err.message)
								})
							}, err => {
								that.loading = false
								that.$message.error(err.message)
							})
						} else {
							orderId = that.payPalOrderIdOld
							const token = $('meta[name="csrf-token"]').attr(
								'content')
							let url = '/paypal/create'
							
							if (that.jump == 1) {
								url = '/paypal/createUrl'
							}
							return fetch(url, {
								method: 'POST',
								headers: {
									'X-CSRF-Token': token
								},
								body: JSON.stringify({
									orderNumber: orderId,
									url:that.jumpUrl 
								})
							}).then(function(res) {
								return res.json();
							}, err => {
								that.$message.error(err.message)
								if (that.payPalOrderIdOld) {
									that.$router.replace({
										path: '/orders/' + that.payPalOrderIdOld + '/pay',
										query: {
											type: 'create'
										}
									})
								}
							}).then(function(orderData) {
								if (orderData.error) {
									that.$message.error(common.text_hint)
									window.location.reload();
								}
								return orderData.id;
							}, err => {
								that.$message.error(err.message)
								if (that.payPalOrderIdOld) {
									that.$router.replace({
										path: '/orders/' + that.payPalOrderIdOld + '/pay',
										query: {
											type: 'create'
										}
									})
								}
							});
						}


					},
					onApprove: function(data, actions) {
						console.log('datadata123', data)
						// /paypal/captureJump
						let url = '/paypal/capture'
						if (that.jump == 1) {
							url = '/paypal/captureUrl'
						}
						const token = $('meta[name="csrf-token"]').attr('content')
						return fetch(url, {
							method: 'POST',
							headers: {
								'X-CSRF-Token': token
							},
							body: JSON.stringify({
								orderNumber: orderId,
								paypalOrderId: data.orderID,
								payment_gateway_id: $("#payapalId").val(),
								url:that.jumpUrl 
							})
						}).then(function(res) {
							// console.log(res.json());
							return res.json();
						}).then(function(orderData) {
							let captureStatus = orderData.status
							if (captureStatus === 'COMPLETED') {
								facebookPixel.track('Purchase',{
									eventID: 'unique_event_id_' + Date.now() // 使用时间戳或其他唯一ID
								});
								if (that.getCookie('login')) {
									that.$router.replace({
										path: '/account/orders/' + orderId
									})
								} else {
									that.$router.replace({
										path: '/success_order_checkout/' + orderId
									})
								}
							}
						});
					},
					onCancel(data) {
						that.loading = true
						if (that.payPalOrderIdOld) {
							that.$router.replace({
								path: '/orders/' + that.payPalOrderIdOld + '/pay',
								query: {
									type: 'create'
								}
							})
						}
					}
				}).render('#paypal-button-container');


			},

			async changeProvince(e) {
				console.log('this.form.province123', e)
				try {
					this.loading = true
					let addressData = await getCheckoutPayWay({
						guest_payment_address: {
							address_1: this.form.address1,
							address_2: this.form.address2 ? this.form.address2 : "",
							city: this.form.city,
							country_id: this.form.country,
							default: true,
							email: this.form.email,
							name: this.form.first_name + ' ' + this.form.last_name,

							first_name: this.form.first_name,
							last_name: this.form.last_name,
							phone: this.form.phone,
							zipcode: this.form.emailCode,
							zone_id: e
						},
						guest_shipping_address: {
							address_1: this.form.address1,
							address_2: this.form.address2 ? this.form.address2 : "",
							city: this.form.city,
							country_id: this.form.country,
							default: true,
							email: this.form.email,
							name: this.form.first_name + ' ' + this.form.last_name,
							first_name: this.form.first_name,
							last_name: this.form.last_name,
							phone: this.form.phone,
							zipcode: this.form.emailCode,
							zone_id: e
						}
					})
					this.localPageData = addressData.data
					const zones = await getZones({
						id: this.form.country
					})

					this.localPageData.zones = zones.data.data.zones

					// this.$forceUpdate()
					this.showPage = false
					this.$nextTick(() => {
						this.showPage = true
						if (this.payWayCode == 'paypal' && this.account != 1) {
							this.createPaypay()
						}
					})
					this.loading = false
					console.log('addressData', addressData)

				} catch (e) {
					console.log('')
					this.loading = false
				}

				// this.initGetData()



			},
			async initGetData() {
				try {
					this.loading = true
					const data = await getCheckoutData()
					this.localPageData = data.data.data
					const zones = await getZones({
						id: data.data.data.country_id
					})
					// console.log('getLocalPageDatazones', zones)
					this.localPageData.zones = zones.data.data.zones
					// 获取默认地址
					if (this.getCookie('login')) {
						const address = await getcheckoutAddress()
						if (address.data.data) {
							localStorage.setItem('address', JSON.stringify(address.data.data))
							console.log('address', address)
						}

					}
					console.log('getLocalPageData', data)
					this.loading = false
				} catch (e) {
					this.loading = false
				}
			},
			getCookie(cname) {
				var name = cname + "=";
				var ca = document.cookie.split(';');
				for (var i = 0; i < ca.length; i++) {
					var c = ca[i].trim();
					if (c.indexOf(name) == 0) return c.substring(name.length, c.length);
				}
				return "";
			},
			async initForm() {
				let address = localStorage.getItem('address')
				// if (!address) {
				// 	const zones = await getZones({
				// 		id: this.localPageData.country_id
				// 	})
				// 	console.log('getLocalPageDatazones', zones)
				// 	this.localPageData.zones = zones.data.data.zones
				// 	return
				// }
				if (address) {
					let newAddress = JSON.parse(address)
					console.log('newAddress', newAddress)
					if (newAddress) {
						this.form.name = newAddress.name
						this.form.email = newAddress.email
						this.form.address1 = newAddress.address_1
						this.form.address2 = newAddress.address_2
						this.form.city = newAddress.city
						this.form.country = ''
						this.form.province = ''
						this.form.first_name = newAddress.first_name
						this.form.last_name = newAddress.last_name
					}

					this.localPageData.countries.forEach(item => {
						if (item.id == newAddress.country_id) {
							this.form.country = newAddress.country_id
						}
					})


					if (this.form.country) {
						const zones = await getZones({
							id: this.form.country
						})
						console.log('getLocalPageDatazones', zones)
						this.localPageData.zones = zones.data.data.zones

						this.localPageData.zones.forEach(item => {
							if (item.id == newAddress.zone_id) {
								this.form.province = newAddress.zone_id
							}
						})
					}
				}




			},
			checkEmail(rule, value, cb) {
				//验证邮箱的正则表达式
				const regEmail = /^([a-zA-Z0-9_-])+@([a-zA-Z0-9_-])+(\.[a-zA-Z0-9_-])+/;
				if (regEmail.test(value)) {
					//合法的邮箱
					return cb();
				}
				//邮箱不合法
				cb(new Error(this.$t('h.errorEmail')));
			},
			async changePayWay(item) {
				console.log('item', item)
				this.loadingPayWay = true
				try {
					this.payWayCode = item.code
					this.account = item.account
					this.jump = item.jump
					this.clientKey = item.client
					this.currencyCode = this.localPageData.currency
					this.jumpUrl = item.url
					console.log('this.currencyCode', this.currencyCode)

					await getCheckoutPayWay({
						payment_method_code: item.code
					})
					this.form.payWay = item.code
					this.loadingPayWay = false
					this.$nextTick(() => {
						if (this.payWayCode == 'paypal' && item.account != 1) {
							this.createPaypay()
						}
					})
				} catch (e) {
					this.loadingPayWay = false
				}
			},
			async submitOrder() {
				if (this.localPageData.shipping_require) {
					if (!this.canPay) {
						if (this.localPageData.payment_methods.length == 0) {
							this.$message.error(this.$t('h.noPayWay'))
						}
						if (this.localPageData.shipping_methods.length == 0) {
							this.$message.error(this.$t('h.noTransportation'))
						}
						return
					}
				}

				if (this.loadingApply || this.loadingPayWay || this.loading) {
					return
				}

				this.$refs['ruleForm'].validate(async (valid) => {
					try {
						if (valid) {
							// alert('submit!');
							this.submitLoading = true
							if (!Cookies.get('login')) {
								let addressData = await getCheckoutPayWay({
									guest_payment_address: {
										address_1: this.form.address1,
										address_2: this.form.address2 ? this.form.address2 : "",
										city: this.form.city,
										country_id: this.form.country,
										default: true,
										email: this.form.email,
										name: this.form.first_name + ' ' + this.form.last_name,

										first_name: this.form.first_name,
										last_name: this.form.last_name,
										phone: this.form.phone,
										zipcode: this.form.emailCode,
										zone_id: this.form.province,
									},
									guest_shipping_address: {
										address_1: this.form.address1,
										address_2: this.form.address2 ? this.form.address2 : "",
										city: this.form.city,
										country_id: this.form.country,
										default: true,
										email: this.form.email,
										name: this.form.first_name + ' ' + this.form.last_name,
										first_name: this.form.first_name,
										last_name: this.form.last_name,
										phone: this.form.phone,
										zipcode: this.form.emailCode,
										zone_id: this.form.province,
									}
								})
								console.log('addressData', addressData)
							} else {
								// let addressData = await getCheckoutAddresses({
								// 	address_1: this.form.address1,
								// 	address_2: this.form.address2 ? this.form.address2 : "",
								// 	city: this.form.city,
								// 	country_id: this.form.country,
								// 	default: true,
								// 	email: this.form.email,
								// 	name: this.form.first_name + ' ' + this.form.last_name,
								// 	first_name: this.form.first_name,
								// 	last_name: this.form.last_name,
								// 	phone: this.form.phone,
								// 	zipcode: this.form.emailCode,
								// 	zone_id: this.form.province,
								// })
								// console.log('addressData', addressData)

								let addressData = await getCheckoutPayWay({
									guest_payment_address: {
										address_1: this.form.address1,
										address_2: this.form.address2 ? this.form.address2 : "",
										city: this.form.city,
										country_id: this.form.country,
										default: true,
										email: this.form.email,
										name: this.form.first_name + ' ' + this.form.last_name,

										first_name: this.form.first_name,
										last_name: this.form.last_name,
										phone: this.form.phone,
										zipcode: this.form.emailCode,
										zone_id: this.form.province,
									},
									guest_shipping_address: {
										address_1: this.form.address1,
										address_2: this.form.address2 ? this.form.address2 : "",
										city: this.form.city,
										country_id: this.form.country,
										default: true,
										email: this.form.email,
										name: this.form.first_name + ' ' + this.form.last_name,
										first_name: this.form.first_name,
										last_name: this.form.last_name,
										phone: this.form.phone,
										zipcode: this.form.emailCode,
										zone_id: this.form.province,
									}
								})
								console.log('addressDataaddressDataaddressData', addressData)
								// if (addressData.name == 'AxiosError') {
								// 	this.submitLoading = false
								// }
								// await getCheckoutData({
								// 	payment_address_id: addressData.data.id,
								// 	shipping_address_id: addressData.data.id,
								// })
							}
							
							facebookPixel.track('AddPaymentInfo',{
								eventID: 'unique_event_id_' + Date.now() // 使用时间戳或其他唯一ID
							});

							let data = await getCheckoutConfirm({
								comment: this.form.comment
							})
							console.log('data', data)
							this.submitLoading = false
							if (data.data.number) {
								// if (this.payWayCode == 'paypal') {
								// 	this.paypalOrderNumber = data.data.number
								// 	return
								// }
								this.$router.replace({
									path: '/orders/' + data.data.number + '/pay',
									query: {
										type: 'create'
									}
								})
							}
						} else {
							this.$message.error(this.$t('h.sippingAddress') + ' Incorrect')
							this.submitLoading = false
							return false;
						}
					} catch (e) {
						console.log('this.submitLoading', e)
						this.submitLoading = false
					}
				});

			},
			async checkCode() {
				console.log('this.formcheckCode', this.form)
				if (this.form.checkCode == '') {
					return
				}
				this.loadingApply = true
				try {
					let checkCode = await getCheckCode({
						discount_code: this.form.checkCode,
						total_amount: this.localPageData.carts.amount
					})
					const data = await getCheckoutData()
					this.localPageData.totals = []
					// localPageData.totals = data.data.data.totals
					data.data.data.totals.forEach(item => {
						this.localPageData.totals.push(item)
					})

					this.loadingApply = false
					this.$forceUpdate()
				} catch (e) {
					this.loadingApply = false
				}
			},
			async changeCountries(e) {
				this.selectLoading = true
				this.localPageData.zones = []
				this.form.province = ''
				console.log('changeCountries', e)
				let zones = await getZones({
					id: e
				})
				this.selectLoading = false
				this.localPageData.zones = zones.data.data.zones
				this.$forceUpdate()
				console.log('zoneszoneszones', this.localPageData.zones)
			},
			submitForm(formName) {
				this.$refs[formName].validate((valid) => {
					if (valid) {
						alert('submit!');
					} else {
						console.log('error submit!!');
						return false;
					}
				});
			},
			resetForm(formName) {
				this.$refs[formName].resetFields();
			}

		}
	}
</script>

<style scoped lang="scss">
	::v-deep .el-input__inner:focus {
		border: solid 1px #675bfa;
	}

	::v-deep .el-textarea__inner:focus {
		border: solid 1px #675bfa;
	}

	::v-deep .el-form-item__label {
		height: 40px;
		font-size: 14px;
		font-weight: bold;
		// color: #000;
		margin: 0px;
		padding: 0px;
	}

	.btn {
		background-color: #ffffff;
		color: #000000;
		border: solid 1px #c2c2c2;
		margin-top: 10px;
	}

	.btn:focus {
		background-color: #ffffff;
		color: #000000;
		border: solid 1px #c2c2c2;
		margin-top: 10px;
	}

	.btn:hover {
		background-color: #000000;
		color: #fff;
		border: solid 1px #000;
	}

	.btn-submit {
		background-color: var(--bgColor);
		color: #ffffff;
		border: solid 1px var(--bgColor);
	}

	.btn-submit:focus {
		background-color: var(--bgColor);
		color: #ffffff;
		border: solid 1px var(--bgColor);
	}

	.btn-submit:hover {
		background-color: #4c4c4c;
		color: #fff;
		border: solid 1px #4c4c4c;
	}

	.text-ellipsis {
		overflow: hidden;
		text-overflow: ellipsis;
		-webkit-line-clamp: 2;
		display: -webkit-box;
		-webkit-box-orient: vertical;
	}
</style>